import styled from 'styled-components';

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 10px;
  display: block;
  > span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #999999;
  }
`;

export const BoxInput = styled.div`
  input[type='text'],
  input[type='number'] {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: 1px solid #c7c7c794;

    &:disabled {
      background-color: #f6f6f6;
    }

    &::placeholder {
      color: #c7c7c794;
    }

    &:active,
    &:focus {
      background: #ffffff;
      background-image: none !important;
    }
  }
`;
